import { SectorsI } from '../interfaces/sectors.interface'
import { SectorsService } from '../services/sectors.service'
import { SectorPayloadT, SectorsGetListResponseT } from '../types/sectors.types'

const sectorsService = new SectorsService()

class SectorsRealisation implements SectorsI {
    getList(): Promise<SectorsGetListResponseT> {
        return sectorsService.getList()
    }

    updateSector(sector_id: number, payload: SectorPayloadT): Promise<void> {
        return sectorsService.updateSector(sector_id, payload)
    }

    createSector(payload: SectorPayloadT): Promise<void> {
        return sectorsService.createSector(payload)
    }

    deleteSector(sector_id: number): Promise<void> {
        return sectorsService.deleteSector(sector_id)
    }
}

export const sectors = new SectorsRealisation()
